import { render, staticRenderFns } from "./FormularioControles.vue?vue&type=template&id=58fcf780"
import script from "./FormularioControles.vue?vue&type=script&lang=js"
export * from "./FormularioControles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports